import { inject, defineComponent, computed, renderSlot, provide, unref, h, onMounted, nextTick, getCurrentScope, onScopeDispose, getCurrentInstance, toRef as toRef$1, readonly, customRef, ref, isRef, watch, watchEffect, useCssVars, defineAsyncComponent, onBeforeUnmount, openBlock, createElementBlock, createVNode, withCtx, createBlock, resolveDynamicComponent, createCommentVNode } from 'vue';

const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};

const key$1 = Symbol("theme");

const defaultTheme = {
  mainColor: {
    base: "#333333",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  fontColor: "#333333",
  actionColor: {
    base: "#32BFC8",
    washed: "rgba(51, 51, 51, 0.24)",
    over: "#2CB0B8",
    contrasted: "#FFFFFF"
  },
  actionContrastColor: {
    base: "#FFFFFF",
    over: "#333333",
    contrasted: "#333333"
  },
  backgroundColor: {
    base: "#FFFFFF",
    over: "#2CB0B8",
    washed: "rgba(51, 51, 51, 0.24)",
    dimmed: "rgba(51, 51, 51, 0.24)",
    contrasted: "#333333"
  },
  backgroundHighlight: true,
  border: false,
  borderColor: "#333333",
  borderRadius: "8px"
};

const useTheme = () => {
  const theme = inject(key$1, defaultTheme);
  return theme;
};

function replaceTokens(message, tokens) {
  if (!tokens) {
    return message;
  }
  return Object.keys(tokens).reduce(
    (acc, token) => acc.replace(`{${token}}`, tokens[token].toString()),
    message
  );
}

const key = Symbol("i18n");

function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};
  if (color instanceof tinycolor) {
    return color;
  }
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  },
  getLuminance: function getLuminance() {
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;
    else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;
    else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;
    else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(color, opts) {
  if (_typeof(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a
  };
}
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;
  if (max == min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    l
  };
}
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p2, q2, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p2 + (q2 - p2) * 6 * t;
    if (t < 1 / 2) return q2;
    if (t < 2 / 3) return p2 + (q2 - p2) * (2 / 3 - t) * 6;
    return p2;
  }
  if (s === 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0;
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    v
  };
}
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [v, q, p, p, t, v][mod], g = [t, v, v, q, p, p][mod], b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}
tinycolor.equals = function(color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}
function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;
  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h, s = hsv.s, v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h,
      s,
      v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}
tinycolor.mix = function(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};
tinycolor.readability = function(color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};
tinycolor.mostReadable = function(baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level,
    size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
var hexNames = tinycolor.hexNames = flip(names);
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }
  if (Math.abs(n - max) < 1e-6) {
    return 1;
  }
  return n % max / parseFloat(max);
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function() {
  var CSS_INTEGER = "[-\\+]?\\d+%?";
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level,
    size
  };
}
function colorHelper(input) {
  const color = tinycolor(input);
  const isDark2 = () => color.getLuminance() <= 0.5;
  const isLight2 = () => !isDark2();
  const darken2 = (amount) => color.darken(amount).toString();
  const lighten2 = (amount) => color.lighten(amount).toString();
  const setAlpha2 = (amount) => color.setAlpha(amount).toString();
  const isReadable = (targetColor) => tinycolor.isReadable(input, targetColor, {
    level: "AA",
    size: "small"
  });
  const getLuminance2 = () => color.getLuminance();
  const wash = () => {
    const targetAlpha = Math.min(
      (1 - color.getLuminance()) / 3,
      0.1
    );
    return color.setAlpha(targetAlpha).toString();
  };
  const dim = () => {
    const colorLuminance = color.getLuminance();
    const targetAlpha = colorLuminance > 0.85 ? colorLuminance : 0.24;
    return tinycolor("#fff").setAlpha(targetAlpha).toString();
  };
  const toHexString2 = () => color.toHexString();
  const isValid2 = () => color.isValid();
  return {
    isDark: isDark2,
    isLight: isLight2,
    darken: darken2,
    lighten: lighten2,
    setAlpha: setAlpha2,
    getLuminance: getLuminance2,
    wash,
    dim,
    toHexString: toHexString2,
    isValid: isValid2,
    isReadable
  };
}
const darkFontColor = "#000000";
const lightFontColor = "#ffffff";
function isAutoValue(value) {
  return value === "auto";
}
function getColorOrFallback(color, fallbackColor) {
  return !color || isAutoValue(color) ? fallbackColor : color;
}
function getContrastColor(color) {
  return !color || colorHelper(color).isReadable(lightFontColor) ? lightFontColor : darkFontColor;
}
function getActionColor(color) {
  let result = color;
  while (colorHelper(result).isLight()) {
    result = colorHelper(result).darken(1);
  }
  return result;
}
function getOverColor(color) {
  return colorHelper(color).getLuminance() < 0.1 ? colorHelper(color).lighten(5) : colorHelper(color).darken(5);
}
function formatColor(color) {
  return !color || isAutoValue(color) || !colorHelper(color).isValid() ? "auto" : colorHelper(color).toHexString();
}
function formatPx(value) {
  if (!value) {
    return "0";
  }
  return value.endsWith("px") ? value : `${value}px`;
}
function formatTheme(theme) {
  return {
    mainColor: formatColor(theme.basics?.mainColor),
    actionColor: formatColor(theme.extra?.actionColor),
    backgroundColor: formatColor(theme.extra?.backgroundColor),
    borderColor: formatColor(theme.extra?.borderColor),
    fontColor: formatColor(theme.extra?.fontColor),
    backgroundHighlight: !theme.extra?.backgroundHighlight ? true : theme.extra.backgroundHighlight === "1",
    border: theme.extra?.border === "1",
    borderRadius: theme.extra?.borderRadius ? formatPx(theme.extra.borderRadius) : "4px"
  };
}
function calculateTheme(theme) {
  const formatedTheme = formatTheme(theme);
  const mainColor = colorHelper(formatedTheme.mainColor).toHexString();
  const actionColor = getActionColor(
    getColorOrFallback(
      formatedTheme.actionColor,
      formatedTheme.mainColor
    )
  );
  const backgroundColor = getColorOrFallback(
    formatedTheme.backgroundColor,
    formatedTheme.mainColor
  );
  const actionContrastColor = getColorOrFallback(
    formatedTheme.actionColor,
    getContrastColor(backgroundColor)
  );
  return {
    mainColor: {
      base: mainColor,
      over: getOverColor(mainColor),
      contrasted: getContrastColor(mainColor)
    },
    fontColor: getColorOrFallback(formatedTheme.fontColor, darkFontColor),
    actionColor: {
      base: actionColor,
      washed: colorHelper(actionColor).wash(),
      over: getOverColor(actionColor),
      contrasted: getContrastColor(actionColor)
    },
    actionContrastColor: {
      base: actionContrastColor,
      over: getOverColor(actionContrastColor),
      contrasted: isAutoValue(formatedTheme.actionColor) ? backgroundColor : getContrastColor(actionContrastColor)
    },
    backgroundColor: {
      base: backgroundColor,
      over: getOverColor(backgroundColor),
      washed: colorHelper(backgroundColor).wash(),
      dimmed: colorHelper(backgroundColor).dim(),
      contrasted: getContrastColor(backgroundColor)
    },
    backgroundHighlight: formatedTheme.backgroundHighlight,
    border: formatedTheme.border,
    borderColor: getColorOrFallback(
      formatedTheme.borderColor,
      formatedTheme.mainColor
    ),
    borderRadius: formatedTheme.borderRadius
  };
}
function provideTheme(theme) {
  if (!theme) {
    throw new Error("Theme is required");
  }
  provide(
    key$1,
    calculateTheme(theme)
  );
}
const pluralRule = ({
  langCode,
  mapper,
  number,
  keysLength
}) => {
  if (number === 0) return 0;
  const name = new Intl.PluralRules(langCode).select(number);
  const result = mapper[name];
  return Math.min(
    keysLength <= Object.keys(mapper).length ? result - 1 : result,
    keysLength - 1
  );
};
const defaultPluralRule = (number, keysLength) => pluralRule({
  langCode: "en-EN",
  mapper: { one: 1, other: 2 },
  number,
  keysLength
});
const arabicPluralRule = (number, keysLength) => {
  const name = new Intl.PluralRules("ar-EG").select(number);
  const result = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  }[name];
  return Math.min(result, keysLength - 1);
};
const slavicPluralRule = (number, keysLength) => pluralRule({
  langCode: "ru-RU",
  mapper: { one: 1, few: 2, many: 3 },
  number,
  keysLength
});
const romanianPluralRule = (number, keysLength) => pluralRule({
  langCode: "ro-RO",
  mapper: { one: 1, few: 2, other: 3 },
  number,
  keysLength
});
const polishPluralRule = (number, keysLength) => pluralRule({
  langCode: "pl-PL",
  mapper: { one: 1, few: 2, many: 3 },
  number,
  keysLength
});
const icelandicPluralRule = (number, keysLength) => pluralRule({
  langCode: "is-IS",
  mapper: { one: 1, other: 2 },
  number,
  keysLength
});
const croatianPluralRule = (number, keysLength) => pluralRule({
  langCode: "hr-HR",
  mapper: { one: 1, few: 2, other: 3 },
  number,
  keysLength
});
const czechPluralRule = (number, keysLength) => pluralRule({
  langCode: "cs-CZ",
  mapper: { one: 1, few: 2, other: 3 },
  number,
  keysLength
});
const asiaticPluralRule = () => 0;
const pluralRulesMap = {
  ar: arabicPluralRule,
  cs: czechPluralRule,
  hr: croatianPluralRule,
  id: asiaticPluralRule,
  is: icelandicPluralRule,
  ja: asiaticPluralRule,
  ko: asiaticPluralRule,
  lt: slavicPluralRule,
  pl: polishPluralRule,
  ro: romanianPluralRule,
  ru: slavicPluralRule,
  uk: slavicPluralRule,
  th: asiaticPluralRule,
  vi: asiaticPluralRule,
  zh: asiaticPluralRule,
  "zh-TW": asiaticPluralRule
};
const DEFAULT_LOCALE = "en";
function provideI18n({ locale, messages, pluralRules }) {
  if (!unref(locale) || !unref(messages)) {
    console.warn("i18n required locale and messages");
  }
  const currentMessages = computed(
    () => unref(messages)[unref(locale) || DEFAULT_LOCALE] || {}
  );
  const translate = (key2, tokens) => replaceTokens(currentMessages.value[key2] || key2, tokens) || key2;
  const translatePlural = (key2, count, tokens) => {
    const pluralKeys = (currentMessages.value[key2] || key2).split("|").map((s) => s.trim());
    const pluralRule2 = unref(pluralRules)?.[unref(locale)] ?? defaultPluralRule;
    return translate(
      pluralKeys[pluralRule2(count, pluralKeys.length)] ?? pluralKeys[0],
      tokens
    );
  };
  const returnObj = {
    t: translate,
    tc: translatePlural
  };
  provide(key, returnObj);
  return returnObj;
}
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "SetupProvider",
  props: {
    config: {}
  },
  setup(__props) {
    const props = __props;
    provideTheme(props.config.payload.deviceStyleConfig);
    provideI18n({
      locale: computed(() => props.config.i18n.locale),
      messages: computed(() => props.config.i18n.messages),
      pluralRules: computed(() => props.config.i18n.pluralRules)
    });
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});

const icon$g = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.9 4.16l.867 1.223c-2.629 1.866-3.255 5.11-1.562 7.614a.75.75 0 01.09.657l-.669 2.006 2.635-.56a.75.75 0 01.48.057 7.527 7.527 0 004.046.703.75.75 0 01.156 1.492 9.027 9.027 0 01-4.615-.733l-3.672.781a.75.75 0 01-.868-.97l.97-2.911c-1.917-3.175-1-7.13 2.141-9.36zm11.35 8.55a.75.75 0 01.207 1.04l-.889 1.333H17.5a.75.75 0 01.624 1.166l-1.667 2.5a.75.75 0 01-1.248-.832l.89-1.334h-1.932a.75.75 0 01-.624-1.166l1.666-2.5a.75.75 0 011.04-.208z" clip-rule="evenodd"/>
  <path d="M4.9 4.16l.867 1.223a6.997 6.997 0 011.564-.831L4.9 4.16z"/>
  <path d="M15.69 4.601c-2.977-2.54-7.576-2.72-10.79-.441l2.431.392c2.457-.934 5.387-.515 7.386 1.19 1.486 1.267 2.161 2.988 2.028 4.658a.75.75 0 101.495.12c.173-2.169-.713-4.352-2.55-5.919z"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$f = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path d="M15.69 4.601c-2.977-2.54-7.576-2.72-10.79-.441-3.142 2.23-4.06 6.184-2.141 9.359l-.97 2.91a.75.75 0 00.867.971l3.671-.78a9.1 9.1 0 006.415.362.75.75 0 00-.45-1.43c-1.777.558-3.795.457-5.548-.393a.75.75 0 00-.483-.06l-2.635.561.669-2.006a.75.75 0 00-.09-.657c-1.693-2.504-1.067-5.748 1.562-7.614 2.177-1.544 5.141-1.718 7.487-.59l2.437-.192z"/>
  <path d="M14.717 5.742a5.912 5.912 0 011.567 2.053l-.593-3.194-2.437.192a6.778 6.778 0 011.463.95z"/>
  <path d="M18.248 10.408c.135-2.131-.751-4.267-2.557-5.807l.593 3.194c.366.807.521 1.668.468 2.518a.75.75 0 101.497.095zM16.583 13.333a.75.75 0 10-1.5 0v2.5a.75.75 0 001.5 0v-2.5zM16.583 18.333a.75.75 0 10-1.5 0v.009a.75.75 0 001.5 0v-.009z"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$e = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.767 5.383c2.663-1.888 6.503-1.728 8.95.36zm8.95.36c1.23 1.049 1.904 2.408 2.025 3.788a.75.75 0 101.494-.132c-.157-1.785-1.027-3.502-2.545-4.798-2.978-2.54-7.577-2.72-10.792-.441-3.141 2.23-4.058 6.184-2.14 9.359l-.97 2.91a.75.75 0 00.867.971l3.671-.78a9.1 9.1 0 006.415.362.75.75 0 10-.45-1.43c-1.777.558-3.795.457-5.548-.393a.75.75 0 00-.483-.06l-2.635.561.669-2.006a.75.75 0 00-.09-.657c-1.693-2.504-1.067-5.748 1.562-7.614m9.605 6.414a2.4 2.4 0 011.565.217l.003.002a2.42 2.42 0 01-1.104 4.567.75.75 0 11-.005-1.5.919.919 0 00.42-1.735.9.9 0 00-1.095.22.75.75 0 11-1.145-.968 2.4 2.4 0 011.36-.803zm.461 5.786a.75.75 0 01.75.75v.009a.75.75 0 11-1.5 0v-.009a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$d = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 6.97a.75.75 0 011.06 0L10 11.44l4.47-4.47a.75.75 0 111.06 1.06l-5 5a.75.75 0 01-1.06 0l-5-5a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$c = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.167 4.917a.917.917 0 00-.846.562L10 9.932l6.679-4.453a.917.917 0 00-.846-.562H4.167zM16.75 7.235l-6.334 4.222a.75.75 0 01-.832 0L3.25 7.235v6.932a.917.917 0 00.917.916h11.666a.917.917 0 00.917-.916V7.235zM2.458 4.125a2.417 2.417 0 011.709-.708h11.666a2.417 2.417 0 012.417 2.416v8.334a2.417 2.417 0 01-2.417 2.416H4.167a2.417 2.417 0 01-2.417-2.416V5.833c0-.64.255-1.255.708-1.708z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$b = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.833 4.917a1.75 1.75 0 00-1.75 1.75v9.022l2.053-2.053a.75.75 0 01.53-.22h7.5a1.75 1.75 0 001.75-1.75v-5a1.75 1.75 0 00-1.75-1.75H5.834zm-2.298-.548a3.25 3.25 0 012.298-.952h8.334a3.25 3.25 0 013.25 3.25v5a3.25 3.25 0 01-3.25 3.25h-7.19L3.864 18.03a.75.75 0 01-1.28-.53V6.667c0-.862.342-1.689.951-2.298zM7.167 7.5a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5h-.008a.75.75 0 01-.75-.75zm4.166 0a.75.75 0 01.75-.75h.009a.75.75 0 010 1.5h-.009a.75.75 0 01-.75-.75zm-3.941 2.798a.75.75 0 011.06.01 2.167 2.167 0 003.096 0 .75.75 0 011.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$a = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.833 4.917a1.75 1.75 0 00-1.75 1.75v9.022l2.053-2.053a.75.75 0 01.53-.22h7.5a1.75 1.75 0 001.75-1.75v-5a1.75 1.75 0 00-1.75-1.75H5.834zm-2.298-.548a3.25 3.25 0 012.298-.952h8.334a3.25 3.25 0 013.25 3.25v5a3.25 3.25 0 01-3.25 3.25h-7.19L3.864 18.03a.75.75 0 01-1.28-.53V6.667c0-.862.342-1.689.951-2.298zm3.132 4.048a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75zm3.333 0a.75.75 0 01.75.75v.008a.75.75 0 11-1.5 0v-.008a.75.75 0 01.75-.75zm3.333 0a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$9 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9.167 3.25a.083.083 0 00-.084.083v5a.083.083 0 00.084.084H15a.75.75 0 01.53.22l1.22 1.219V3.333a.083.083 0 00-.083-.083h-7.5zm-1.12-1.036c.297-.297.7-.464 1.12-.464h7.5a1.584 1.584 0 011.583 1.583v8.334a.75.75 0 01-1.28.53l-2.28-2.28H9.166a1.583 1.583 0 01-1.584-1.584v-5c0-.42.167-.822.464-1.12zm-4.714 6.87a.083.083 0 00-.083.083v6.522l1.22-1.22A.75.75 0 015 14.25h5.833a.084.084 0 00.084-.083V12.5a.75.75 0 011.5 0v1.667a1.583 1.583 0 01-1.584 1.583H5.311l-2.28 2.28a.75.75 0 01-1.281-.53V9.167a1.583 1.583 0 011.583-1.584H5a.75.75 0 010 1.5H3.333z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$8 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 2.378a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zM10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM6.75 7.5a.75.75 0 01.75-.75h.008a.75.75 0 110 1.5H7.5a.75.75 0 01-.75-.75zm5 0a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75zm-5.614 2.803a.75.75 0 01.53-.22h6.667a.75.75 0 01.75.75 4.084 4.084 0 01-8.166 0 .75.75 0 01.22-.53zm1.392 1.28a2.583 2.583 0 004.944 0H7.528z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$7 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-3.157-.872a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zm.24 4.58c.66 0 1.532.26 1.921 1.04a.75.75 0 11-1.341.67c-.028-.053-.197-.21-.58-.21-.382 0-.552.156-.579.21a.75.75 0 11-1.341-.67c.39-.78 1.261-1.04 1.92-1.04zm5.834 0c.659 0 1.53.26 1.92 1.04a.75.75 0 11-1.341.67c-.027-.053-.197-.21-.58-.21-.382 0-.551.156-.579.21a.75.75 0 01-1.341-.67c.39-.78 1.261-1.04 1.92-1.04zm-5.525 5.006a.75.75 0 011.06.011 2.165 2.165 0 003.096 0 .75.75 0 111.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$6 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M18.03 1.97a.75.75 0 01.175.785l-5.416 15a1.208 1.208 0 01-2.214.072l-2.8-5.601-5.602-2.8a1.208 1.208 0 01.072-2.215l15-5.416a.75.75 0 01.785.175zm-8.784 9.845l2.377 4.753 4.03-11.16-6.407 6.407zm5.346-7.467l-11.16 4.03 4.753 2.376 6.407-6.406z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$5 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9.583 4.917c-.608 0-1.173.208-1.574.552-.397.34-.592.774-.592 1.198a.75.75 0 11-1.5 0c0-.903.419-1.74 1.116-2.337.693-.595 1.612-.913 2.55-.913h.834c.938 0 1.857.318 2.55.913.692.592 1.11 1.421 1.116 2.316a3.25 3.25 0 01-2.126 3.214c-.321.16-.637.472-.87.938a3.45 3.45 0 00-.338 1.67.75.75 0 11-1.498.064 4.948 4.948 0 01.494-2.405c.361-.722.912-1.315 1.603-1.64a.744.744 0 01.07-.028 1.75 1.75 0 001.165-1.792c0-.424-.195-.858-.592-1.198-.4-.344-.966-.552-1.574-.552h-.834zM10 15.084a.75.75 0 01.75.75v.008a.75.75 0 01-1.5 0v-.008a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$4 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M16.186 3.32a.916.916 0 00-.999.199l-1.609 1.61a5.005 5.005 0 011.296 1.297l1.61-1.611a.917.917 0 00-.298-1.495zm-.632 4.547a5.004 5.004 0 01-1.097 4.745l-.014.015-.147.153-.011.012-1.556 1.556a2.15 2.15 0 00-.626 1.37l-.005.166v.765c0 .472-.188.923-.519 1.255a1.175 1.175 0 01-1.563.09l-.058-.05a.74.74 0 01-.042-.039l-7.82-7.82a1.178 1.178 0 01-.256-1.281c.059-.142.146-.272.255-.381m0 0a1.775 1.775 0 011.097-.513l.116-.006a.746.746 0 01.043-.001h.777c.52 0 1.02-.189 1.412-.527l.121-.114 1.547-1.546.012-.012.133-.128.012-.01a5.004 5.004 0 014.773-1.119l1.988-1.989a2.416 2.416 0 113.419 3.417l-1.99 1.992m-7.17-1.2l-.122.115-1.55 1.55a.74.74 0 01-.018.018l-.14.13a3.656 3.656 0 01-2.426.922h-.596l7.065 7.064v-.595-.026l.007-.192a3.65 3.65 0 011.063-2.366l1.55-1.55.133-.14a3.504 3.504 0 00-.127-4.82M3.154 9.023s.001 0 0 0zm5.23-2.358a3.504 3.504 0 014.84.11m-9.89 6.64a.75.75 0 01.75.75 1.75 1.75 0 001.75 1.75.75.75 0 010 1.5 3.25 3.25 0 01-3.25-3.25.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$3 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 2.378a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 2.378zM10 3.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM6.75 8.333a.75.75 0 01.75-.75h.008a.75.75 0 110 1.5H7.5a.75.75 0 01-.75-.75zm5 0a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75zm-4.358 3.631a.75.75 0 011.06.011 2.165 2.165 0 003.096 0 .75.75 0 111.071 1.05 3.666 3.666 0 01-5.238 0 .75.75 0 01.01-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$2 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M7.113 3.779a4.083 4.083 0 115.774 5.775 4.083 4.083 0 01-5.774-5.775zM10 4.083a2.583 2.583 0 100 5.167 2.583 2.583 0 000-5.167zm-1.667 10a2.584 2.584 0 00-2.583 2.583v1.667a.75.75 0 01-1.5 0v-1.667a4.083 4.083 0 014.083-4.083h.417a.75.75 0 010 1.5h-.417zm3.354-.76a2.618 2.618 0 013.316-.272 2.619 2.619 0 013.317.283 2.537 2.537 0 01-.005 3.632l-.001.002-2.789 2.734a.75.75 0 01-1.05 0l-2.795-2.746a2.537 2.537 0 01.007-3.634zm1.825.76c-.291 0-.572.113-.78.316a1.035 1.035 0 00-.004 1.484l.002.002 2.27 2.23 2.27-2.224a1.036 1.036 0 00.002-1.484 1.12 1.12 0 00-1.56-.005l-.001.002-.184.18a.75.75 0 01-1.052-.001l-.183-.181-.002-.001a1.119 1.119 0 00-.778-.318z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon$1 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M7.113 3.779a4.083 4.083 0 115.774 5.775 4.083 4.083 0 01-5.774-5.775zM10 4.083a2.583 2.583 0 100 5.167 2.583 2.583 0 000-5.167zm-1.667 10a2.583 2.583 0 00-2.583 2.583v1.667a.75.75 0 01-1.5 0v-1.667a4.083 4.083 0 014.083-4.083h2.917a.75.75 0 010 1.5H8.333zm7.039-1.453a2.4 2.4 0 011.565.217l.003.002a2.42 2.42 0 01-1.104 4.567.75.75 0 11-.005-1.5.92.92 0 00.42-1.735.9.9 0 00-1.095.22.75.75 0 11-1.145-.968 2.4 2.4 0 011.36-.803zm.461 5.786a.75.75 0 01.75.75v.009a.75.75 0 01-1.5 0v-.009a.75.75 0 01.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const icon = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.53 5.363c-.886.887-1.28 2.465-1.28 5.47 0 2.918.371 4.49 1.204 5.39a4.083 4.083 0 013.88-2.807h3.333a4.083 4.083 0 013.879 2.808c.833-.9 1.204-2.473 1.204-5.391 0-3.005-.394-4.583-1.28-5.47-.887-.886-2.465-1.28-5.47-1.28s-4.583.394-5.47 1.28zm9.684 11.708a2.584 2.584 0 00-2.547-2.155H8.333a2.583 2.583 0 00-2.547 2.155c.947.35 2.287.512 4.214.512 1.927 0 3.267-.162 4.214-.512zM3.47 4.303c1.363-1.364 3.535-1.72 6.53-1.72s5.167.356 6.53 1.72c1.364 1.363 1.72 3.535 1.72 6.53s-.356 5.167-1.72 6.53c-1.363 1.364-3.535 1.72-6.53 1.72s-5.167-.356-6.53-1.72C2.106 16 1.75 13.828 1.75 10.833s.356-5.167 1.72-6.53zm4.232 2.565a3.25 3.25 0 114.596 4.597 3.25 3.25 0 01-4.596-4.597zM10 7.416a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const chatIconMap = {
  MessageChatbotIcon: icon$b,
  BubbleBoltIcon: icon$g,
  BubbleExclamationIcon: icon$f,
  BubbleQuestionIcon: icon$e,
  ChevronDownIcon: icon$d,
  MessagesIcon: icon$9,
  MoodHappyIcon: icon$8,
  MoodSmileBeamIcon: icon$7,
  SmileIcon: icon$3,
  EnvelopeIcon: icon$c,
  MessageDotsIcon: icon$a,
  PaperPlaneIcon: icon$6,
  QuestionMarkIcon: icon$5,
  SchoolBellIcon: icon$4,
  UserHeartIcon: icon$2,
  UserQuestionIcon: icon$1,
  UserSquareRoundedIcon: icon
};
const chatIconList = Object.entries(chatIconMap).map(([name, component]) => ({
  name,
  component: () => component
}));
const getIconComponent = (iconName) => chatIconMap[iconName] || null;

const keyConfig = Symbol("config");
const keyChatConnection = Symbol("chatConnection");

var MessageOwner = /* @__PURE__ */ ((MessageOwner2) => {
  MessageOwner2["USER"] = "user";
  MessageOwner2["ASSISTANT"] = "assistant";
  MessageOwner2["SYSTEM"] = "system";
  return MessageOwner2;
})(MessageOwner || {});

var e={"":["<em>","</em>"],_:["<strong>","</strong>"],"*":["<strong>","</strong>"],"~":["<s>","</s>"],"\n":["<br />"]," ":["<br />"],"-":["<hr />"]};function n(e){return e.replace(RegExp("^"+(e.match(/^(\t| )+/)||"")[0],"gm"),"")}function r(e){return (e+"").replace(/"/g,"&quot;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function t(a,c){var o,l,g,s,p,u=/((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm,m=[],h="",i=c||{},d=0;function f(n){var r=e[n[1]||""],t=m[m.length-1]==n;return r?r[1]?(t?m.pop():m.push(n),r[0|t]):r[0]:n}function $(){for(var e="";m.length;)e+=f(m[m.length-1]);return e}for(a=a.replace(/^\[(.+?)\]:\s*(.+)$/gm,function(e,n,r){return i[n.toLowerCase()]=r,""}).replace(/^\n+|\n+$/g,"");g=u.exec(a);)l=a.substring(d,g.index),d=u.lastIndex,o=g[0],l.match(/[^\\](\\\\)*\\$/)||((p=g[3]||g[4])?o='<pre class="code '+(g[4]?"poetry":g[2].toLowerCase())+'"><code'+(g[2]?' class="language-'+g[2].toLowerCase()+'"':"")+">"+n(r(p).replace(/^\n+|\n+$/g,""))+"</code></pre>":(p=g[6])?(p.match(/\./)&&(g[5]=g[5].replace(/^\d+/gm,"")),s=t(n(g[5].replace(/^\s*[>*+.-]/gm,""))),">"==p?p="blockquote":(p=p.match(/\./)?"ol":"ul",s=s.replace(/^(.*)(\n|$)/gm,"<li>$1</li>")),o="<"+p+">"+s+"</"+p+">"):g[8]?o='<img src="'+r(g[8])+'" alt="'+r(g[7])+'">':g[10]?(h=h.replace("<a>",'<a href="'+r(g[11]||i[l.toLowerCase()])+'">'),o=$()+"</a>"):g[9]?o="<a>":g[12]||g[14]?o="<"+(p="h"+(g[14]?g[14].length:g[13]>"="?1:2))+">"+t(g[12]||g[15],i)+"</"+p+">":g[16]?o="<code>"+r(g[16])+"</code>":(g[17]||g[1])&&(o=f(g[17]||"--"))),h+=l,h+=o;return (h+a.substring(d)+$()).replace(/^\n+|\n+$/g,"")}

function parseMarkdown(text) {
  const markdownLinks = [];
  const markdownLinkRegex = /\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/gi;
  let textWithProtectedLinks = text.replace(markdownLinkRegex, (match, linkText, url) => {
    const index = markdownLinks.length;
    markdownLinks.push({ full: match, text: linkText, url });
    return `[${linkText}](MARKDOWNLINKPLACEHOLDER${index})`;
  });
  const standaloneUrls = [];
  const standaloneUrlRegex = /(?<!\]\()https?:\/\/[^\s<>[\]{}|\\^`"')]+/gi;
  textWithProtectedLinks = textWithProtectedLinks.replace(standaloneUrlRegex, (match) => {
    const index = standaloneUrls.length;
    standaloneUrls.push(match);
    return `STANDALONEURLPLACEHOLDER${index}`;
  });
  let processedText = t(textWithProtectedLinks).replace(/<pre class="code poetry">/g, "<div>").replace(/<\/pre>/g, "</div>").replace(/<code>/g, "<ul><li>").replace(/<\/code>/g, "</li></ul>");
  markdownLinks.forEach((link, index) => {
    const placeholder = `MARKDOWNLINKPLACEHOLDER${index}`;
    processedText = processedText.replace(
      new RegExp(`href="${placeholder}"`, "g"),
      `href="${link.url}"`
    );
  });
  standaloneUrls.forEach((url, index) => {
    const placeholder = `STANDALONEURLPLACEHOLDER${index}`;
    processedText = processedText.replace(
      new RegExp(placeholder, "g"),
      url
    );
  });
  processedText = processedText.replace(
    /<a(?![^>]*\btarget=)/g,
    '<a target="_blank" rel="noopener noreferrer"'
  );
  return processedText;
}

const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "ConfigProvider",
  props: {
    config: {}
  },
  setup(__props) {
    const props = __props;
    provide(keyConfig, props.config);
    const logger = computed(() => props.config.logger || console);
    const resultConfig = computed(() => {
      logger.value.debug("THN: props.config", { ...props.config });
      return {
        ...props.config
      };
    });
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default", { config: resultConfig.value });
    };
  }
});

const generateUniqueId = () => {
  const timestamp = Date.now().toString(36);
  const randomNum = Math.random().toString(36).substring(2, 10);
  return timestamp + randomNum;
};

function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
function toValue(r) {
  return typeof r === "function" ? r() : unref(r);
}
const isClient = typeof window !== "undefined" && typeof document !== "undefined";
const isWorker = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const toString = Object.prototype.toString;
const isObject = (val) => toString.call(val) === "[object Object]";
const noop = () => {
};
function getLifeCycleTarget(target) {
  return getCurrentInstance();
}
function toRef(...args) {
  if (args.length !== 1)
    return toRef$1(...args);
  const r = args[0];
  return typeof r === "function" ? readonly(customRef(() => ({ get: r, set: noop }))) : ref(r);
}
function tryOnMounted(fn, sync = true, target) {
  const instance = getLifeCycleTarget();
  if (instance)
    onMounted(fn, target);
  else if (sync)
    fn();
  else
    nextTick(fn);
}
function useIntervalFn(cb, interval = 1e3, options = {}) {
  const {
    immediate = true,
    immediateCallback = false
  } = options;
  let timer = null;
  const isActive = ref(false);
  function clean() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  function pause() {
    isActive.value = false;
    clean();
  }
  function resume() {
    const intervalValue = toValue(interval);
    if (intervalValue <= 0)
      return;
    isActive.value = true;
    if (immediateCallback)
      cb();
    clean();
    timer = setInterval(cb, intervalValue);
  }
  if (immediate && isClient)
    resume();
  if (isRef(interval) || typeof interval === "function") {
    const stopWatch = watch(interval, () => {
      if (isActive.value && isClient)
        resume();
    });
    tryOnScopeDispose(stopWatch);
  }
  tryOnScopeDispose(pause);
  return {
    isActive,
    pause,
    resume
  };
}

function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...args) {
  let target;
  let events2;
  let listeners;
  let options;
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    [events2, listeners, options] = args;
    target = defaultWindow;
  } else {
    [target, events2, listeners, options] = args;
  }
  if (!target)
    return noop;
  if (!Array.isArray(events2))
    events2 = [events2];
  if (!Array.isArray(listeners))
    listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options2) => {
    el.addEventListener(event, listener, options2);
    return () => el.removeEventListener(event, listener, options2);
  };
  const stopWatch = watch(
    () => [unrefElement(target), toValue(options)],
    ([el, options2]) => {
      cleanup();
      if (!el)
        return;
      const optionsClone = isObject(options2) ? { ...options2 } : options2;
      cleanups.push(
        ...events2.flatMap((event) => {
          return listeners.map((listener) => register(el, event, listener, optionsClone));
        })
      );
    },
    { immediate: true, flush: "post" }
  );
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
function useMounted() {
  const isMounted = ref(false);
  const instance = getCurrentInstance();
  if (instance) {
    onMounted(() => {
      isMounted.value = true;
    }, instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useMediaQuery(query, options = {}) {
  const { window: window2 = defaultWindow } = options;
  const isSupported = useSupported(() => window2 && "matchMedia" in window2 && typeof window2.matchMedia === "function");
  let mediaQuery;
  const matches = ref(false);
  const handler = (event) => {
    matches.value = event.matches;
  };
  const cleanup = () => {
    if (!mediaQuery)
      return;
    if ("removeEventListener" in mediaQuery)
      mediaQuery.removeEventListener("change", handler);
    else
      mediaQuery.removeListener(handler);
  };
  const stopWatch = watchEffect(() => {
    if (!isSupported.value)
      return;
    cleanup();
    mediaQuery = window2.matchMedia(toValue(query));
    if ("addEventListener" in mediaQuery)
      mediaQuery.addEventListener("change", handler);
    else
      mediaQuery.addListener(handler);
    matches.value = mediaQuery.matches;
  });
  tryOnScopeDispose(() => {
    stopWatch();
    cleanup();
    mediaQuery = void 0;
  });
  return matches;
}
const DEFAULT_PING_MESSAGE = "ping";
function resolveNestedOptions(options) {
  if (options === true)
    return {};
  return options;
}
function useWebSocket(url, options = {}) {
  const {
    onConnected,
    onDisconnected,
    onError,
    onMessage,
    immediate = true,
    autoClose = true,
    protocols = []
  } = options;
  const data = ref(null);
  const status = ref("CLOSED");
  const wsRef = ref();
  const urlRef = toRef(url);
  let heartbeatPause;
  let heartbeatResume;
  let explicitlyClosed = false;
  let retried = 0;
  let bufferedData = [];
  let pongTimeoutWait;
  const _sendBuffer = () => {
    if (bufferedData.length && wsRef.value && status.value === "OPEN") {
      for (const buffer of bufferedData)
        wsRef.value.send(buffer);
      bufferedData = [];
    }
  };
  const resetHeartbeat = () => {
    clearTimeout(pongTimeoutWait);
    pongTimeoutWait = void 0;
  };
  const close = (code = 1e3, reason) => {
    if (!isClient || !wsRef.value)
      return;
    explicitlyClosed = true;
    resetHeartbeat();
    heartbeatPause == null ? void 0 : heartbeatPause();
    wsRef.value.close(code, reason);
    wsRef.value = void 0;
  };
  const send = (data2, useBuffer = true) => {
    if (!wsRef.value || status.value !== "OPEN") {
      if (useBuffer)
        bufferedData.push(data2);
      return false;
    }
    _sendBuffer();
    wsRef.value.send(data2);
    return true;
  };
  const _init = () => {
    if (explicitlyClosed || typeof urlRef.value === "undefined")
      return;
    const ws = new WebSocket(urlRef.value, protocols);
    wsRef.value = ws;
    status.value = "CONNECTING";
    ws.onopen = () => {
      status.value = "OPEN";
      onConnected == null ? void 0 : onConnected(ws);
      heartbeatResume == null ? void 0 : heartbeatResume();
      _sendBuffer();
    };
    ws.onclose = (ev) => {
      status.value = "CLOSED";
      onDisconnected == null ? void 0 : onDisconnected(ws, ev);
      if (!explicitlyClosed && options.autoReconnect) {
        const {
          retries = -1,
          delay = 1e3,
          onFailed
        } = resolveNestedOptions(options.autoReconnect);
        retried += 1;
        if (typeof retries === "number" && (retries < 0 || retried < retries))
          setTimeout(_init, delay);
        else if (typeof retries === "function" && retries())
          setTimeout(_init, delay);
        else
          onFailed == null ? void 0 : onFailed();
      }
    };
    ws.onerror = (e) => {
      onError == null ? void 0 : onError(ws, e);
    };
    ws.onmessage = (e) => {
      if (options.heartbeat) {
        resetHeartbeat();
        const {
          message = DEFAULT_PING_MESSAGE
        } = resolveNestedOptions(options.heartbeat);
        if (e.data === message)
          return;
      }
      data.value = e.data;
      onMessage == null ? void 0 : onMessage(ws, e);
    };
  };
  if (options.heartbeat) {
    const {
      message = DEFAULT_PING_MESSAGE,
      interval = 1e3,
      pongTimeout = 1e3
    } = resolveNestedOptions(options.heartbeat);
    const { pause, resume } = useIntervalFn(
      () => {
        send(message, false);
        if (pongTimeoutWait != null)
          return;
        pongTimeoutWait = setTimeout(() => {
          close();
          explicitlyClosed = false;
        }, pongTimeout);
      },
      interval,
      { immediate: false }
    );
    heartbeatPause = pause;
    heartbeatResume = resume;
  }
  if (autoClose) {
    if (isClient)
      useEventListener("beforeunload", () => close());
    tryOnScopeDispose(close);
  }
  const open = () => {
    if (!isClient && !isWorker)
      return;
    close();
    explicitlyClosed = false;
    retried = 0;
    _init();
  };
  if (immediate)
    open();
  watch(urlRef, open);
  return {
    data,
    status,
    close,
    send,
    open,
    ws: wsRef
  };
}
function useWindowSize(options = {}) {
  const {
    window: window2 = defaultWindow,
    initialWidth = Number.POSITIVE_INFINITY,
    initialHeight = Number.POSITIVE_INFINITY,
    listenOrientation = true,
    includeScrollbar = true
  } = options;
  const width = ref(initialWidth);
  const height = ref(initialHeight);
  const update = () => {
    if (window2) {
      if (includeScrollbar) {
        width.value = window2.innerWidth;
        height.value = window2.innerHeight;
      } else {
        width.value = window2.document.documentElement.clientWidth;
        height.value = window2.document.documentElement.clientHeight;
      }
    }
  };
  update();
  tryOnMounted(update);
  useEventListener("resize", update, { passive: true });
  if (listenOrientation) {
    const matches = useMediaQuery("(orientation: portrait)");
    watch(matches, () => update());
  }
  return { width, height };
}

function useWebsocket(endpoint, logger = console) {
  const {
    status,
    data: message,
    send: sendWebSocketMessage,
    open: openWebSocketConnection,
    close: closeConnection
  } = useWebSocket(endpoint, {
    autoClose: true,
    immediate: false,
    autoReconnect: false,
    heartbeat: {
      interval: 3e4,
      message: JSON.stringify({
        heartbeat: true
      }),
      pongTimeout: 5e3
    },
    onConnected: (connection) => {
      logger.debug("THN: KITT Agent connected", connection);
    },
    onDisconnected: (connection) => {
      logger.debug("THN: KITT Agent disconnected", connection);
    },
    onMessage: (_, data) => {
      logger.debug("THN: KITT Agent message", data);
    },
    onError: (connection, event) => {
      logger.debug("THN: KITT Agent error", connection, event);
    }
  });
  watch(status, (newStatus) => {
    logger.debug("THN: WebSocket status changed to:", newStatus);
  });
  const isConnected = computed(() => status.value === "OPEN");
  return {
    isConnected,
    message,
    sendWebSocketMessage,
    openWebSocketConnection,
    closeConnection
  };
}

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "KittChatWidget",
  props: {
    config: {}
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "0540f4d8": htmlDirection.value,
      "4cdfd891": unref(theme)?.actionColor?.base,
      "4ce60e94": unref(theme)?.actionColor?.over
    }));
    const syncMessagesScroll = ref();
    const typingQueue = [];
    let isTypingStream = false;
    async function appendCharByChar({
      target,
      content,
      delay = 20
    }) {
      return new Promise((resolve) => {
        let i = 0;
        async function typeChar() {
          if (i < content.length) {
            target.content += content[i];
            if (typeof syncMessagesScroll.value === "function") {
              await syncMessagesScroll.value();
            }
            i += 1;
            setTimeout(typeChar, delay);
          } else {
            resolve();
          }
        }
        typeChar();
      });
    }
    async function queueTyping(target, content, delay = 20) {
      typingQueue.push(async () => {
        isTypingStream = true;
        await appendCharByChar({ target, content, delay });
        isTypingStream = false;
        typingQueue.shift();
        if (typingQueue.length > 0) {
          typingQueue[0]();
        }
      });
      if (!isTypingStream && typingQueue.length === 1) {
        typingQueue[0]();
      }
    }
    const props = __props;
    const KittChatDesktop = defineAsyncComponent(
      () => import('./chunks/KittChatDesktop.B-VyOMNu.js')
    );
    const KittChatMobile = defineAsyncComponent(
      () => import('./chunks/KittChatMobile.FR2OafIq.js')
    );
    const isConfigured = computed(() => !!props.config?.deviceStyleConfig && !Array.isArray(props.config.deviceStyleConfig));
    const kittIdFromSocket = ref(null);
    const connectionData = computed(() => ({
      language: props.config.language,
      site_id: props.config.siteId,
      kitt_id: props.config.kittId || kittIdFromSocket.value,
      country: props.config.country || "",
      device: props.config.device,
      fingerprint: props.config.fingerprint,
      stream: !!(props.config.deviceStyleConfig?.streaming ?? false)
    }));
    const {
      isConnected,
      message,
      sendWebSocketMessage,
      openWebSocketConnection,
      closeConnection
    } = useWebsocket(props.config.endpoint);
    const messages = ref([]);
    const isTyping = ref(false);
    const rootEl = ref();
    const widget = ref();
    const i18nMessages = ref({});
    const theme = useTheme();
    const componentType = computed(() => {
      switch (props.config.device) {
        case "mobile":
          return KittChatMobile;
        default:
          return KittChatDesktop;
      }
    });
    const providerConfig = computed(() => {
      const params = new URLSearchParams(window.location.search);
      const queryInitialStatus = params.get("kitt-initialStatus");
      const showClosed = queryInitialStatus ? queryInitialStatus !== "opened" : props.config?.deviceStyleConfig?.initialStatus === void 0 || props.config?.deviceStyleConfig?.initialStatus === "closed";
      const position = props.config?.deviceStyleConfig?.position || "LR";
      const deviceStyleConfig = {
        ...props.config.deviceStyleConfig,
        extra: {
          ...props.config.deviceStyleConfig.extra,
          border: props.config.deviceStyleConfig.extra?.border === "1" ? "1" : "0"
        }
      };
      return {
        payload: {
          ...props.config,
          deviceStyleConfig,
          showClosed,
          position
        },
        i18n: {
          locale: props.config.language,
          messages: i18nMessages.value,
          pluralRules: pluralRulesMap
        }
      };
    });
    const htmlDirection = computed(() => props.config.isRightAlign ? "rtl" : "ltr");
    function collapse() {
      if (widget.value?.collapse) {
        widget.value.collapse();
      }
    }
    function openConnection() {
      if (isConnected.value) return;
      openWebSocketConnection();
      sendWebSocketMessage(
        JSON.stringify({
          ...connectionData.value
        })
      );
    }
    function sendMessage(content, owner) {
      if (!isConnected.value) {
        openWebSocketConnection();
      }
      sendWebSocketMessage(
        JSON.stringify({
          messages: [
            {
              role: owner || MessageOwner.USER,
              content: typeof content === "string" ? content : JSON.stringify(content)
            }
          ],
          ...connectionData.value
        })
      );
      if (owner === MessageOwner.SYSTEM) return;
      messages.value.push({
        id: generateUniqueId(),
        content: typeof content === "string" ? parseMarkdown(content) : parseMarkdown(content.content),
        owner: owner || MessageOwner.USER
      });
      const loadingMessageId = generateUniqueId();
      messages.value.push({
        id: loadingMessageId,
        owner: MessageOwner.ASSISTANT,
        content: "",
        loading: true
      });
    }
    function handleSendMessage(content, owner) {
      sendMessage(content, owner);
    }
    provide(keyChatConnection, {
      messages,
      isConnected,
      sendMessage,
      openConnection,
      syncMessagesScroll,
      closeConnection
    });
    watch(message, () => {
      const response = JSON.parse(message.value);
      if (response.action === "end_of_conversation") {
        const endOfConversationMessage = {
          id: generateUniqueId(),
          content: "",
          owner: MessageOwner.ASSISTANT,
          conversationEnd: true
        };
        messages.value.push(endOfConversationMessage);
        return;
      }
      if (response.choices?.length === 0) return;
      if (response.kitt_id && !kittIdFromSocket.value) {
        kittIdFromSocket.value = response.kitt_id;
        return;
      }
      if (response.choices?.length > 1) {
        messages.value = [];
        response.choices.forEach(
          (choice) => {
            const messageContent = choice.message.content;
            if (messageContent?.trim().length > 0) {
              messages.value.push({
                id: generateUniqueId(),
                owner: choice.message.role,
                content: parseMarkdown(messageContent)
              });
            }
          }
        );
        return;
      }
      if (messages.value.length === 1 && response.choices[0].finish_reason === null) {
        return;
      }
      const loadingIndex = messages.value.findIndex((m) => m.loading);
      if (loadingIndex !== -1) {
        messages.value.splice(loadingIndex, 1);
      }
      const isStreaming = response.choices[0]?.delta?.content !== void 0;
      if (isStreaming) {
        const content = response.choices[0]?.delta.content;
        const role = response.choices[0]?.delta.role;
        if (content && loadingIndex !== -1) {
          messages.value.push({
            id: generateUniqueId(),
            owner: role || MessageOwner.ASSISTANT,
            content
          });
        } else if (content) {
          const lastMsg = messages.value[messages.value.length - 1];
          queueTyping(lastMsg, content);
        }
      } else {
        const content = response.choices[0]?.message.content;
        const role = response.choices[0]?.message.role;
        if (content) {
          messages.value.push({
            id: response.id,
            owner: role || MessageOwner.ASSISTANT,
            content
          });
        }
      }
    });
    watch(
      () => props.config.language,
      async (newLang) => {
        try {
          const currentLangMessages = await __variableDynamicImportRuntimeHelper((/* #__PURE__ */ Object.assign({"./locales/ar.json": () => import('./chunks/ar.BVUI9B9z.js'),"./locales/bg.json": () => import('./chunks/bg.DdniM2L4.js'),"./locales/ca.json": () => import('./chunks/ca.Br8YdOfJ.js'),"./locales/cs.json": () => import('./chunks/cs.D2rJFa04.js'),"./locales/da.json": () => import('./chunks/da.CG7wiCaI.js'),"./locales/de.json": () => import('./chunks/de.m3rZXUvA.js'),"./locales/el.json": () => import('./chunks/el.C4dHwsRm.js'),"./locales/en.json": () => import('./chunks/en.nJig4pd5.js'),"./locales/es.json": () => import('./chunks/es.DO4rYeoU.js'),"./locales/et.json": () => import('./chunks/et.BtJAIGiT.js'),"./locales/eu.json": () => import('./chunks/eu.CZecWGw1.js'),"./locales/fi.json": () => import('./chunks/fi.DloHcj6m.js'),"./locales/fr.json": () => import('./chunks/fr.CUgv98dd.js'),"./locales/he.json": () => import('./chunks/he.CFvHRWGY.js'),"./locales/hr.json": () => import('./chunks/hr.Bv3sWSe6.js'),"./locales/hu.json": () => import('./chunks/hu.CDybjgQy.js'),"./locales/id.json": () => import('./chunks/id.BtXRqfsv.js'),"./locales/is.json": () => import('./chunks/is.f8f5zbjQ.js'),"./locales/it.json": () => import('./chunks/it.DP84q-7X.js'),"./locales/ja.json": () => import('./chunks/ja.u1BWLCqF.js'),"./locales/ko.json": () => import('./chunks/ko.DUIHL4Zk.js'),"./locales/lt.json": () => import('./chunks/lt.fd8QREra.js'),"./locales/nl.json": () => import('./chunks/nl.D0hn2ruS.js'),"./locales/no.json": () => import('./chunks/no.BepJ-F7K.js'),"./locales/pl.json": () => import('./chunks/pl.DXidXS1H.js'),"./locales/pt.json": () => import('./chunks/pt.Beab5nuV.js'),"./locales/ro.json": () => import('./chunks/ro.DAz_u60b.js'),"./locales/ru.json": () => import('./chunks/ru.CtfKwUV5.js'),"./locales/sl.json": () => import('./chunks/sl.DnWLODw-.js'),"./locales/sv.json": () => import('./chunks/sv.iowJSAj-.js'),"./locales/th.json": () => import('./chunks/th.DM8qbtL0.js'),"./locales/tr.json": () => import('./chunks/tr.D8IJpRwp.js'),"./locales/uk.json": () => import('./chunks/uk.DVM5yR_O.js'),"./locales/vi.json": () => import('./chunks/vi.B-_gGECu.js'),"./locales/zh-TW.json": () => import('./chunks/zh-TW.DvggveBf.js'),"./locales/zh.json": () => import('./chunks/zh.BONBwdQB.js')})), `./locales/${newLang}.json`, 3);
          i18nMessages.value = {
            [newLang]: currentLangMessages.default
          };
        } catch (error) {
          i18nMessages.value = {};
          console.warn("THN: Error loading i18n messages");
        }
      },
      { immediate: true }
    );
    function destroy() {
      closeConnection();
    }
    onBeforeUnmount(async () => {
      closeConnection();
    });
    __expose({
      collapse,
      destroy
    });
    return (_ctx, _cache) => {
      return isConfigured.value ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref_key: "rootEl",
        ref: rootEl,
        class: "thn--widget thn--widget-kittchat root w-full"
      }, [
        createVNode(unref(_sfc_main$2), { config: providerConfig.value }, {
          default: withCtx(() => [
            createVNode(_sfc_main$1, {
              config: providerConfig.value.payload
            }, {
              default: withCtx(({ config: transformedConfig }) => [
                (openBlock(), createBlock(resolveDynamicComponent(componentType.value), {
                  ref_key: "widget",
                  ref: widget,
                  modelValue: messages.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => messages.value = $event),
                  "is-typing": isTyping.value,
                  config: transformedConfig,
                  onSendMessage: handleSendMessage
                }, null, 40, ["modelValue", "is-typing", "config"]))
              ]),
              _: 1
            }, 8, ["config"])
          ]),
          _: 1
        }, 8, ["config"])
      ], 512)) : createCommentVNode("", true);
    };
  }
});

const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const KittChatWidget = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b6881bef"]]);

export { MessageOwner as M, _export_sfc as _, useTheme as a, keyConfig as b, icon$7 as c, chatIconList, chatIconMap, keyChatConnection as d, KittChatWidget as default, generateUniqueId as g, getIconComponent, icon$9 as i, key as k, parseMarkdown as p, replaceTokens as r, useWindowSize as u };
//# sourceMappingURL=kittchat.es.js.map
